import { render, staticRenderFns } from "./MoveItem.vue?vue&type=template&id=dab9d4d0&scoped=true&"
import script from "./MoveItem.vue?vue&type=script&lang=ts&"
export * from "./MoveItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab9d4d0",
  null
  
)

export default component.exports